"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var types_1 = require("../types");
function gcd(a, b) {
    if (!b)
        return a;
    return gcd(b, Math.floor(a % b));
}
function decimalToFractional(decimal) {
    var _a = decimal.split('.'), int = _a[0], r = _a[1];
    if (!r)
        return int + "/1";
    var denominator = Math.pow(10, r.length);
    var numerator = +int * denominator + +r;
    var divisor = gcd(numerator, denominator);
    return numerator / divisor + "/" + denominator / divisor;
}
function formatDecimalOdd(coef, oddFormat) {
    var value = +coef - 1;
    if (lodash_1.isNaN(value))
        return coef;
    switch (oddFormat) {
        case types_1.App.OddFormat.Fractional: {
            return decimalToFractional("" + lodash_1.round(value, 2));
        }
        case types_1.App.OddFormat.US: {
            var usValue = value >= 1 ? +(100 * value) : -100 / value;
            return (usValue > 0 ? '+' : '') + lodash_1.floor(usValue);
        }
        case types_1.App.OddFormat.HongKong: {
            return lodash_1.floor(value, 3);
        }
        case types_1.App.OddFormat.Indo: {
            var result = value >= 1 ? value : (1 / value) * -1;
            return lodash_1.floor(result, 3);
        }
        case types_1.App.OddFormat.Malay: {
            var result = value <= 1 ? value : (1 / value) * -1;
            return lodash_1.floor(result, 3);
        }
        default: {
            return lodash_1.floor(+coef, 2);
        }
    }
}
exports.default = formatDecimalOdd;
//# sourceMappingURL=formatDecimalOdd.js.map